var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form-group",
    _vm._b(
      {
        attrs: {
          "invalid-feedback": _vm.invalidFeedback,
          label: _vm.label,
          "label-for": _vm.formControlId,
        },
      },
      "b-form-group",
      _vm.$attrs,
      false
    ),
    [
      _c("csp-form-select-searchable", {
        attrs: {
          id: _vm.formControlId,
          "allow-empty": !_vm.isRequiredProperty,
          "auto-select-single-option": _vm.autoSelectSingleOption,
          "default-value": _vm.defaultValue,
          "disable-change-trigger": _vm.disableChangeTrigger,
          disabled: _vm.isReadOnlyProperty || _vm.dependencyDisabled,
          "open-direction": _vm.openDirection,
          options: _vm.internalOptions,
          "options-loader": _vm.optionsLoader,
          placeholder: _vm.placeholder,
          property: _vm.property,
          "reset-after": _vm.resetAfter,
          state: _vm.validationState,
          "value-empty": _vm.valueEmpty,
        },
        on: { change: _vm.handleSelect },
        model: {
          value: _vm.data[_vm.property],
          callback: function ($$v) {
            _vm.$set(_vm.data, _vm.property, $$v)
          },
          expression: "data[property]",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }